<template>
    <svg
        width="25"
        height="18"
        viewBox="0 0 25 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.1512 12.6775C14.1937 12.6775 15.8494 11.0218 15.8494 8.97936C15.8494 6.93695 14.1937 5.28125 12.1512 5.28125C10.1088 5.28125 8.45312 6.93695 8.45312 8.97936C8.45312 11.0218 10.1088 12.6775 12.1512 12.6775Z"
        />
        <path
            d="M23.5595 6.50063C21.9896 4.07299 18.4185 0 12.1509 0C5.88337 0 2.31231 4.07299 0.742381 6.50063C-0.24746 8.02074 -0.24746 9.94148 0.742381 11.4616C2.31231 13.8893 5.88337 17.9623 12.1509 17.9623C18.4185 17.9623 21.9896 13.8893 23.5595 11.4616C24.5493 9.94148 24.5493 8.02074 23.5595 6.50063ZM12.1509 14.7475C8.79681 14.7475 6.07771 12.1658 6.07771 8.98111C6.07771 5.79646 8.79681 3.21475 12.1509 3.21475C15.5051 3.21475 18.2242 5.79646 18.2242 8.98111C18.2208 12.1645 15.5037 14.7443 12.1509 14.7475Z"
        />
    </svg>
</template>

<script>
export default {
    setup() {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
